import { Component, OnInit } from '@angular/core';
import { LoginService } from '../services/login.service';
import { AlertController, ToastController } from '@ionic/angular';
import { jwtDecode } from 'jwt-decode';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-tabs',
  templateUrl: 'tabs.page.html',
  styleUrls: ['tabs.page.scss']
})
export class TabsPage implements OnInit {
  currentLang: string; // Add this property
  isLoggedIn: boolean = false;
  firstName: string | null = null;
  lastName: string | null = null;
  mykadNumber: string | null = null;
  email: string | null = null;
  school: string | null = null;
  state: string | null = null;
  showVoiceSetup = false;
  isSpeechSynthesisSupported = 'speechSynthesis' in window;
  isWindows = navigator.platform.indexOf('Win') > -1;
  isMac = navigator.platform.indexOf('Mac') > -1;
  isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || 
          (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  isAndroid = /Android/.test(navigator.userAgent);

  constructor(
    private loginService: LoginService,
    private alertController: AlertController,
    private toastController: ToastController,
    private translate: TranslateService
  ) {
    // Initialize currentLang in constructor
    this.currentLang = this.translate.currentLang || 'en';
  }

  async ngOnInit() {
    // Subscribe to language changes
    this.translate.onLangChange.subscribe(event => {
      this.currentLang = event.lang;
    });

    const token = await this.loginService.getToken();

    if (token) {
      const decodedToken: any = jwtDecode(token);
      this.mykadNumber = decodedToken?.data?.mykad;
      const userDetails = await this.loginService.getUserDetails();

      if (userDetails) {
        this.firstName = userDetails.firstName;
        this.lastName = userDetails.lastName;
        this.email = userDetails.email;
        this.school = userDetails.school;
        this.state = userDetails.state;
      }
      this.isLoggedIn = true;
    }
  }

  switchLanguage(lang: string) {
    this.translate.use(lang);
    this.currentLang = lang; // Update currentLang when switching
  }
  
    onLoginSubmit(): void {
      if (!this.mykadNumber) {
        const errorTitle = this.translate.instant('error');
        const errorMessage = this.translate.instant('mykad_required');
        this.presentAlert(errorTitle, errorMessage);
        return;
      }

    this.loginService.loginUser(this.mykadNumber).subscribe({
      next: (response) => {
        this.isLoggedIn = true;
        this.loginService.saveUserDetails(response.first_name, response.last_name, response.user_email, response.educational_name, response.state, response.phone_number, response.category, response.country);

        this.firstName = response.first_name;  
        this.lastName = response.last_name;    
        this.email = response.user_email;  // Set email from the response
        this.school = response.educational_name;  // Set email from the response
        this.state = response.state;  // Set state from the response

        this.loginService.saveToken(response.token).then(() => {
          this.loginService.setAuthState(true); // Set authentication state to true
        });
        const ToastAnchor = this.translate.instant('Login successful!');
        this.presentToast(ToastAnchor);

      },
      error: (error) => {
        const errorTitle = this.translate.instant('error');
        if (error.error.code === 'login_failed') {
            const errorMessage = this.translate.instant('login_failed');
            this.presentAlert(errorTitle, errorMessage);
        } else {
            const genericError = this.translate.instant('generic_error');
            this.presentAlert(errorTitle, genericError);
        }
    }
    
    });
  }
  
  // Example methods to show alerts and toasts:
  async presentAlert(header: string, message: string) {
    const okButtonText = this.translate.instant('ok_button');
    const alert = await this.alertController.create({
      header: header,
      message: message,
      buttons: [okButtonText]
    });
  
    await alert.present();
}

  async presentToast(message: string) {
    const toast = await this.toastController.create({
      message: message,
      duration: 2000
    });
    toast.present();
  }

  async signOut() {
    await this.loginService.signOut();
    this.isLoggedIn = false;
    this.firstName = null;
    this.lastName = null;
    this.mykadNumber = null;
    this.school = null;
    this.state = null;
    this.loginService.setAuthState(false); // Set authentication state to false

    // Optionally, you can add a toast or alert to notify the user they've signed out.
    const ToastAnchor = this.translate.instant('Logout successful!');
    this.presentToast(ToastAnchor);
}

}